/** @format */

import React from "react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { showNotification } from "@mantine/notifications";
import { Skeleton, Pagination, Button, Text } from "@mantine/core";
import { useNavigate } from "react-router-dom";

import { getAllBlogs, deleteBlog } from "../../utilities/apis/blogs";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { selectUserData } from "../../redux/selectors";
import UniversalTable from "../../components/Common/UniversalTable";

function Blogs() {
  const navigate = useNavigate();
  const userData = useSelector(selectUserData);

  const [blogs, setBlogs] = useState();
  const [uiConfigs, setUiConfigs] = useState({
    pageLoading: false,
    page: 1,
  });

  const fetchBlogs = async () => {
    setUiConfigs((preState) => ({ ...preState, pageLoading: true }));
    const resp = await apiWrapWithErrorWithData(
      getAllBlogs({ page: uiConfigs.page })
    );
    if (resp?.success) {
      setBlogs(resp);
    } else {
      // showNotification({
      //   color: "red",
      //   title: "Blogs",
      //   message: "Something went wrong.",
      // });
    }
    setUiConfigs((preState) => ({ ...preState, pageLoading: false }));
  };

  useEffect(() => {
    fetchBlogs();
  }, [uiConfigs.page]);

  const onDelete = async (id) => {
    const resp = await apiWrapWithErrorWithData(deleteBlog({ blogId: id }));
    if (resp?.success) {
      fetchBlogs();
      // navigate("/app/blog-manager");
      showNotification({
        color: "green",
        title: "Blogs",
        message: `Blog is deleted`,
      });
    }
  };

  const blogTableHeaders = [
    { label: "Reference No", key: "id" },
    { label: "Title", key: "title" },
    {
      label: "Created By",
      key: "createdBy",
      render: (row) => (
        <Text size="sm" weight={500} className="text-slate-700">
          {row.createdBy?.name}
        </Text>
      ),
    },
    {
      label: "",
      key: "actions",
      render: (row) =>
        userData?.designation === "Admin" ? (
          <Button
            style={{ backgroundColor: "red", color: "white" }}
            onClick={() => onDelete(row.id)}
          >
            Delete
          </Button>
        ) : null,
    },
  ];

  return (
    <div>
      {uiConfigs.pageLoading ? (
        Array.from({ length: 10 }, (_, i) => i).map(() => (
          <Skeleton height={30} radius="md" className="my-1 w-full" />
        ))
      ) : (
        <div>
          <div className="flex justify-between my-4">
            <Text>Blogs</Text>
            <Button
              onClick={() => {
                navigate("/app/blog-manager/create");
              }}
            >
              Create Blog
            </Button>
          </div>
          <div className="flex flex-col">
            <UniversalTable
              headers={blogTableHeaders}
              data={blogs?.data || []}
              loading={uiConfigs.pageLoading}
              emptyMessage="No blogs found"
            />
          </div>
          {blogs?.blogsCount ? (
            <>
              <div className="flex flex-row justify-center my-4">
                <Pagination
                  page={uiConfigs.page}
                  onChange={(page) => {
                    setUiConfigs({
                      ...uiConfigs,
                      page,
                    });
                  }}
                  total={Math.ceil(blogs.blogsCount / 10)}
                />
              </div>
            </>
          ) : null}
        </div>
      )}
    </div>
  );
}

export default Blogs;
